import { useEffect } from "react";
import { UserManager } from 'oidc-client-ts';

/**
 * Silent callback handler for OIDC silent authentication.
 * This page is loaded in a hidden iframe during silent sign-in.
 * It processes the authentication response and communicates back to the parent window.
 */
function SilentCallback() {
    useEffect(() => {
        async function processSilentCallback() {
            try {
                // Create a temporary UserManager just to process the callback
                const userManager = new UserManager({
                    authority: 'https://preprodidentity.accessacloud.com',
                    client_id: 'access.evo-adoption-andrada',
                    response_type: 'code',
                });
                
                await userManager.signinSilentCallback();
                console.log('Silent callback processed successfully');
            } catch (error) {
                console.error('Error processing silent callback:', error);
            }
        }

        processSilentCallback();
    }, []);

    // This component renders nothing - it's just for processing the callback
    return null;
}

export default SilentCallback;
